import { Typography, View } from '@sapphire-react/core';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

type TextSection = {
  introText: string;
  categoryName: string;
  categoryDescription: string;
};

type Props = {
  tKey: string;
};

export const FollowingQuestionsTooltip = ({ tKey }: Props) => {
  const { t } = useTranslation();

  const tooltipData = t(tKey, { returnObjects: true }) as Record<string, TextSection[]>;

  return (
    <View>
      {Object.keys(tooltipData).map((paragraphKey, idx) => (
        <Fragment key={paragraphKey}>
          <Typography.Body size={'sm'} aria-live={'polite'}>
            {tooltipData[paragraphKey].map(({ introText, categoryName, categoryDescription }, sectionIdx) => (
              <span key={sectionIdx}>
                <span style={{ fontWeight: 'normal' }}>{introText} </span>
                <span style={{ fontWeight: 'bold' }}>{categoryName} </span>
                <span style={{ fontWeight: 'normal' }}>{categoryDescription}</span>
              </span>
            ))}
          </Typography.Body>
          {idx < Object.keys(tooltipData).length - 1 && <br />}
        </Fragment>
      ))}
    </View>
  );
};
